
import { ProductService } from "@/services";
import { v4 } from "uuid";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			fetchedParentGroups: [] as string[],
			fetchedSubGroups: [] as string[],
			parentFetchThread: "",
			subFetchThread: ""
		};
	},
	props: {
		mainGroup: String,
		subGroup: String,
		light: Boolean
	},
	computed: {
		noMainGroup():boolean {
			return this.mainGroup.trim() == "";
		}
	},
	methods: {
		async fetchParentGroups(){
			let threadId = v4();
			this.parentFetchThread = threadId;
			let result = await ProductService.searchSimpleMainGroup(this.mainGroup);
			if (this.parentFetchThread != threadId) return;
			this.fetchedParentGroups = result;
		},
		async fetchSubGroups(){
			if (!this.mainGroup) {
				this.fetchedSubGroups = [];
				return;
			}
			let threadId = v4();
			let mainGroup = this.mainGroup;
			this.subFetchThread = threadId;
			let result = await ProductService.searchSimpleSubGroup(this.mainGroup, this.subGroup);
			if (this.subFetchThread != threadId) return;
			if (this.mainGroup != mainGroup) return;
			this.fetchedSubGroups = result;
		},
		onMainGroupInput(value:string){
			value = value.trim();
			this.$emit("update:mainGroup", value);
			if (value == "") {
				this.$emit("update:subGroup", "");
			}
			this.fetchParentGroups();
		},
		onSubGroupInput(value:string){
			value = value.trim();
			this.$emit("update:subGroup", value);
			this.fetchSubGroups();
		},
		clearGroup(){
			this.onMainGroupInput("");
		}
	},
	async mounted(){
		await this.fetchParentGroups();
		await this.fetchSubGroups();
	},
	i18nEx: {
		componentPrefix: "components.products"
	}
});
